import React from "react";
import moment, {max} from "moment"
import styles from "./DaySelect.module.scss";
import useAppSelector from "../../hooks/useAppSelector";

type DaySelectProps = {
    dateArray: string[],
    currentDate: string,
    setCurrentDate(value: string): void,
    setNumberForWeer(value: number): void,
    numberForWeek: number,
    additionalFunction?: () => void,
    forEventCalendar?: boolean
}
const DaySelect: React.FC<DaySelectProps> = ({
                                                 dateArray,
                                                 currentDate,
                                                 setCurrentDate,
                                                 setNumberForWeer,
                                                 numberForWeek,
                                                 additionalFunction,
                                                 forEventCalendar
                                             }) => {

    const {profile} = useAppSelector(state => state.profileSlice);
    const {gymSettings} = useAppSelector(state => state.gymSettingsSlice);

    const getDayByDate = (date: string) => {
        return moment(date).format("ddd");
    }

    const getNumberOfTheMonth = (date: string) => {
        return moment(date).format("DD");
    }

    const getDayAndMonth = (date: string) => {
        return moment(date).format("DD MMMM");
    }

    const checkIsCustomerCanIncreaseWeek = () => {
        if (profile && forEventCalendar && gymSettings) {
            let calendarNextWeeks = gymSettings.calAllowedWeeks ? gymSettings.calAllowedWeeks : 1;
            let maxDate = moment(new Date()).endOf("week").toDate();
            let openDay;
            let openDayNumber;

            const openHour = gymSettings.calOpenHour;
            if (profile.isPremium) {
                openDay = translateDayNameOfWeek(gymSettings.calSpecialDay);
                openDayNumber = dayNameToNumber(gymSettings.calSpecialDay);
            } else {
                openDay = translateDayNameOfWeek(gymSettings.calStandardDay);
                openDayNumber = dayNameToNumber(gymSettings.calStandardDay);
            }
            let sundayDays = 0;
            if (openDayNumber === 0) {
                sundayDays = 7;
            }
            if (moment().isBefore(moment().day(openDay).hour(openHour).add(sundayDays, "days"))) {
                calendarNextWeeks--;
            }
            maxDate = moment().endOf("isoWeek").add(calendarNextWeeks, "week").toDate();
            if (moment(maxDate).isSameOrAfter(moment().add(numberForWeek + 7, "day").endOf("isoWeek"))) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    const translateDayNameOfWeek = (day: string) => {
        const weekDays = [
            {id: "sunday"},
            {id: "monday"},
            {id: "tuesday"},
            {id: "wednesday"},
            {id: "thursday"},
            {id: "friday"},
            {id: "saturday"}
        ];
        const dayOfWeek = weekDays.find(x => x.id === day) || weekDays[3];
        return dayOfWeek.id;
    }

    const dayNameToNumber = (day: string) => {
        if (day === "monday") {
            return 1;
        } else if (day === "tuesday") {
            return 2;
        } else if (day === "wednesday") {
            return 3;
        } else if (day === "thursday") {
            return 4;
        } else if (day === "friday") {
            return 5;
        } else if (day === "saturday") {
            return 6;
        } else if (day === "sunday") {
            return 0;
        }
    }

    return (
        <div>
            <div className={styles.changeWeek}>
                {
                    numberForWeek > 0 && <button onClick={() => {
                        setNumberForWeer(numberForWeek - 7)
                    }} className={styles.btn}>
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.1406 36.1396L7.00063 23.9996L19.1406 11.8596" stroke="#303030" strokeWidth="4"
                            strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M41 24L7.34 24" stroke="#303030" strokeWidth="4" strokeMiterlimit="10"
                            strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>

                  </button>
                }
                <p className={styles.date}>{getDayAndMonth(dateArray[0])} - {getDayAndMonth(dateArray[dateArray.length - 1])}</p>
                {checkIsCustomerCanIncreaseWeek() && (
                    <button onClick={() => {
                        setNumberForWeer(numberForWeek + 7)
                    }} className={styles.btn}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28.8594 11.8604L40.9994 24.0004L28.8594 36.1404" stroke="#303030" strokeWidth="4"
                                  strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M7 24H40.66" stroke="#303030" strokeWidth="4" strokeMiterlimit="10"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>

                    </button>
                )}
            </div>
            <div className={styles.wrapper}>
                {
                    dateArray.map(date => {
                        return (
                            <div onClick={() => {
                                setCurrentDate(date)
                                if (additionalFunction) {
                                    additionalFunction();
                                }
                            }} key={date}
                                 className={`${styles.item} ${moment(currentDate).startOf("day").toISOString() === moment(date).startOf("day").toISOString() ? styles.active : ''}`}>
                            <p className={styles.day}>{getDayByDate(date)}</p>
                                <span className={styles.number}>{getNumberOfTheMonth(date)}</span>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default DaySelect;